import TabsList, { TabsListProps } from './TabsList';

export type { TabsListProps };
export default TabsList;
